import React, {useState} from "react"

import Datatable from "../../components/datatable";
import Loader from "../../components/loader";
import Widget from "../../components/widget";
import {FcOk} from "react-icons/fc";
import moment from "moment";

const TableDataServices = ({data, setItem, loading}) => {

   if(loading) return <Loader/>
   if (!data) return null

   let columns = [
       {Header: 'Subjekt',accessor: d => (
               <div className={"flex-col"}>
                   <div>{d.subjectName}</div>
                   <div>Od: {moment(d.cronFrom).format("D. M. YYYY HH:mm")}</div>
                   <div>Do: {moment(d.cronTo).format("D. M. YYYY HH:mm")}</div>
               </div>
           )
       },
      {Header: 'Událost',accessor: d => (
            <div className={"flex-col"}>
                <div>{d.eventName}</div>
                <div>{moment(d.startTime).format("D. M. YYYY HH:mm")}</div>
            </div>
          )
      },
       {Header: 'Počty',accessor: d => (
               <div className={"flex-col"}>
                   <div>Vstupenek: {d.ticketCount}</div>
                   <div>Průchodů: {d.ticketEntrance}</div>
               </div>
           )
       },
      {
         Header: 'Joby', accessor: d => (
            <div className={"text-xs label label-info flex-col"}>
                {d.subjectJobs.map(i => <div>{i.name}</div>)}
            </div>

         )
      },
       {
           Header: 'Statusy', accessor: d => (
               <div className={"text-xs label label-info flex-col"}>
                   <div>Import: {d.importDone && moment(d.importDone).format("D. M. YYYY HH:mm")}</div>
                   <div>Ticket update: {d.ticketUpdateAt && moment(d.ticketUpdateAt).format("D. M. YYYY HH:mm")}</div>
                   <div>Entrance update: {d.entrancesUpdateAt && moment(d.entrancesUpdateAt).format("D. M. YYYY HH:mm")}</div>
               </div>
           )
       },
      {Header: 'Importováno', accessor: d => (
              d.imported ? <div><FcOk size={20}/></div> : <div className={"bg-red-400 text-white text-center rounded"}>Neimportováno !!</div>
         )},

   ];


   return (
      <Widget title={"Dnešní události"}>
         <Datatable data={data} columns={columns} showPagination={data.length>=10}/>
      </Widget>
   )
}

export default TableDataServices
